import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="bg-card border border-border rounded-lg p-8">
          <h2 className="font-heading text-xl mb-1">Yeni şifre belirleyin</h2>
          <p className="text-sm text-muted-foreground mb-6">Hesabınız için yeni bir şifre girin.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wide text-muted-foreground">Yeni Şifre</Label>
              <Input id="password" type="password" required data-testid="reset-password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-secondary border-border" placeholder="En az 6 karakter" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
            <Button type="submit" disabled={loading || !token} data-testid="reset-submit"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-medium">
              {loading ? "Güncelleniyor..." : "Şifreyi Güncelle"}
            </Button>
          </form>
          <Link to="/login" data-testid="back-to-login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-primary hover:underline">
            <ArrowLeft size={16} /> Girişe dön
          </Link>
        </div>
      </div>
    </div>
  );
}
